const RouterPackage = require("react-router-dom");
const Router = RouterPackage.HashRouter;
const Route = RouterPackage.Route;
const Navigate = RouterPackage.Navigate;
const Routes = RouterPackage.Routes;
export default RouterPackage;
export { Router, Route, Navigate, Routes };
